import { WebSocketFactory } from 'global-web-socket-client-js/global-web-socket-client-js-bundle.min.js';
import { Logger } from '../helpers/Logger'
import { SingletonSharedData } from '../singletonSharedData'

let webSocketClient = null;
let wsServer = null;
let _port = null;
let _that = null;
let token = null;
let sharedData = null;
let _isOpen = false;

export default class SingletonWebSocket {

    constructor() {
        this._dataCall = null;
    }

    static setwsServer(server) {
        Logger.Trace("WebSocket Server: ", server);
        wsServer = server;
    }

    static setUserId(value) {
        if (webSocketClient) {
            webSocketClient.setUserId(value);
        }
    }

    static SetOnMessage(that) {
        _that = that;
    }
    static setPort(port) {
        Logger.Trace("WebSocket Port: ", port);
        _port = port;
    }

    static connect(secureConnection = false) {
        sharedData = new SingletonSharedData();
        if (!token) {
            let helperFrameWindow = document.getElementById('helperFrame').contentWindow;

            let getUserId = () => {
                helperFrameWindow.postMessage('getNuxibaTokenAgent', '*');
            }

            let messageEvent = (event) => {
                if (!token && typeof event.data === "string") {
                    token = event.data;
                    window.removeEventListener('message', messageEvent);
                    console.log("getNuxibaTokenAgent", token);

                    SingletonWebSocket.validate();
                    webSocketClient.connect(secureConnection);
                }
            }
            window.addEventListener('message', messageEvent);

            getUserId();
        } else {
            SingletonWebSocket.validate();
            webSocketClient.connect(secureConnection);
        }
    }

    static validate() {
        if (!webSocketClient) {
            webSocketClient = new WebSocketFactory().buildClient();
            webSocketClient.WSParameter.serverIP = wsServer;
            webSocketClient.WSParameter.port = _port;
            webSocketClient.WSParameter.keepAliveTimeRequest = 30000;
            webSocketClient.WSParameter.keepAliveTimeResponse = 5000;
            webSocketClient.WSParameter.keepAliveMessage = `{client : "galatea", action: "KeepAlive", ip:"${token}"}`;
            webSocketClient.WSParameter.onClose = () => {
                if (_that && _that.onCloseIntegration) {
                    _that.onCloseIntegration();
                }
            }
            webSocketClient.WSParameter.onMessage = (message) => {
                Logger.Trace("Socket Response", message);
                if (message.data === "added" && _that && _that.onOpenIntegration) {
                    _that.onOpenIntegration();
                }
                else if (_that && _that.onIntegrationMessage) {
                    _that.onIntegrationMessage(JSON.parse(message.data));
                }
            }
            webSocketClient.WSParameter.onOpen = () => {
                _isOpen = true;
                let message = { action: "firstConnection" };
                SingletonWebSocket.send(message);

            };
            webSocketClient.WSParameter.onError = (err) => {
                _isOpen = false;
                if (_that && _that.onError) {
                    _that.onError(err);
                }
            };
        }
    }

    static send(message) {
        if (webSocketClient && _isOpen) {
            message.agentId = sharedData.getUserData() ? sharedData.getUserData().User_id : 0;
 
            message.userName = sharedData.getUserData() ? sharedData.getUserData().Login : "0";

             
 
 
            message.ip = token;
            message.client = "galatea";
            webSocketClient.send(JSON.stringify(message));
            _that.addIntegrationLog("Message Sent", message)
        }
    }

    static getJson(action, subaction, data) {
        var dataObject = !data || typeof (data) === "undefined" ? "" : data;
        return {
            client: "galatea",
            data: dataObject,
            action: action,
            subaction: subaction
        };
    }

    static getJsonError(code, message) {
        return {
            code,
            message
        };
    }

    static close() {
        if (webSocketClient) {
            webSocketClient.close();
            webSocketClient = null;
        }
    }

    set dataCall(dataCall) {
        this._dataCall = dataCall;
    }

    get dataCall() {
        return this._dataCall;
    }
}


// WEBPACK FOOTER //
// ./src/js/Singletons/SingletonWebSocket.js